export default "__VITE_ASSET__C_KIJgbT__"